<template>
<div style="height:100%">
<div class="main-container" v-show="isShow">
   <div class="search-box">
    <div class="search-item">
      <label>商品名：</label>
      <a-input placeholder="请输入" v-model="searchTerm.mdseName" />
    </div>
    <div class="search-item">
      <label>商品类目：</label>
      <a-select v-model="searchTerm.primaryCategoryId"   @select="handleCategoryChange" placeholder="请选择大类" 
        :getPopupContainer="triggerNode => triggerNode.parentNode"
        option-filter-prop="children" show-search allowClear>
        <a-select-option v-for="category in categoryList" :key="category.id" >
          {{ category.categoryName }}
        </a-select-option>
      </a-select>
      <a-select v-model="searchTerm.secondaryCategoryId"  v-show="searchTerm.primaryCategoryId" placeholder="请选择小类"  @select="handleSecCategoryChange"
        :getPopupContainer="triggerNode => triggerNode.parentNode"
        option-filter-prop="children" show-search allowClear>
        <a-select-option v-for="secCategory in secCategoryList" :key="secCategory.id">
          {{ secCategory.categoryName}}
        </a-select-option>
      </a-select>
    </div>
    <br>
    <div class="search-item">
      <label>供应商账号名：</label>
      <a-input placeholder="请输入" v-model="searchTerm.supplierAlias" />
    </div>
    <div class="search-item">
      <label>供应商账号：</label>
      <a-input placeholder="请输入" v-model="searchTerm.supplierAccount" />
    </div>
    <div class="search-btn">
      <a-button type="primary" @click="search">查询</a-button>
      <a-button @click="reset">重置</a-button>
    </div>
  </div>
  <a-tabs type="card" @change="callback">
    <a-tab-pane :key="1" tab="全部">
    </a-tab-pane>
    <a-tab-pane :key="10" tab="待审核">
    </a-tab-pane>
    <a-tab-pane :key="20" tab="审核不通过">
    </a-tab-pane>
    <a-tab-pane :key="30" tab="审核通过待授权">
    </a-tab-pane>
    <a-tab-pane :key="40" tab="已授权">
    </a-tab-pane>
  </a-tabs>
  <div class="table-btn">
    <a-checkbox @change="onClick" v-model="checked" ref="checkbox" v-show="tabsKey!=20">
    当页全选
    </a-checkbox>
    <a-button @click="audit(30)" v-show="tabsKey==1||tabsKey==10">审核通过</a-button>
    <a-button @click="audit(20)" v-show="tabsKey==1||tabsKey==10">审核不通过</a-button>
    <a-button @click="openModal(1)" v-show="tabsKey!=10&&tabsKey!=20">授权渠道商</a-button>
    <a-button @click="openModal(3)" class="last-btn" v-show="tabsKey!=20" >类目授权渠道商</a-button>
  </div>

  <a-table 
    :locale="{
      emptyText: '暂无数据'
    }"
    rowKey="mdseId" 
    :columns="columns" 
    :data-source="data" 
    :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
    @change="handleTableChange" 
    :pagination="pagination"  
    style="margin-top: 12px;"
  >
    <span slot="mdseName" slot-scope="text" class="mdseName">
        <img :src="text.mdseImgPathList[0]" alt="">
				<span :title="text.mdseName">{{text.mdseName}}</span>
    </span>
    <span slot="categoryNodeList" slot-scope="text">{{text|categoryF}}</span>
    <span slot="mdseStatus" slot-scope="text" >{{text|statusFormat}}</span>
    <a slot="action" slot-scope="text,record" @click="openModal(2,record.mdseId)">查看详情</a>
  </a-table>
  <transfer ref="transfer" @getdata="getdata"/>

</div>
<router-view/> 
</div>
  
</template>
<script>
import {batchAudit,} from '@/api/product'
import page from "@/assets/mixin/page.js";
import transfer from "./components/transfer"
const columns = [
  {
    title: '商品名',
    key: 'mdseName',
    width:'20%',
    scopedSlots: { customRender: 'mdseName' },
  },{
    title: '品牌',
    dataIndex: 'brand',
    key: 'brand',
    ellipsis: true,
  },{
    title: '类目',
    scopedSlots: { customRender: 'categoryNodeList' },
  },{
    title: '供应商账号',
    dataIndex: 'supplierAccount',
    width:'12%',
  },{
    title: '供应商名',
    dataIndex: 'supplierAlias',
    ellipsis: true,
  },{
    title: '提交时间',
    dataIndex: 'createTime',
    // width:'16%',
    ellipsis: true,
  },
  {
    title: '状态',
    key: 'mdseStatus',
    dataIndex: 'mdseStatus',
    scopedSlots: { customRender: 'mdseStatus' },
  },
  {
    title: '操作',
    key: 'action',
    scopedSlots: { customRender: 'action' },
  },
];

export default {
  name:'pms',
  mixins: [page],
  components:{transfer},
  data() {
    return {
      tabsKey:1,
      categoryList: [],
      secCategoryList: [],
      data:[],
      selectedRowKeys: [],
      columns,
      checked:false,
			searchTerm:{
				primaryCategoryId:undefined,
				secondaryCategoryId:undefined,
			},
    };
  },
  filters:{
    categoryF(value) {
      let label = "";
      label = value.primaryCategoryName + ">";
      value.categoryNodeList&&value.categoryNodeList.forEach(item => {
        label += item.name + "、";
      });
      return label.substr(0, label.length - 1);
    },
    statusFormat(value) {
      switch (value) {
        case 10:
          return "待审核";
          break;
        case 20:
          return "审核不通过";
          break;
        case 30:
          return "待授权";
          break;
        case 40:
          return "已授权";
          break;
      }
    },
    
  },
  created(){
    this.getdata()
    this.getCatagory();
  },
  watch: {
    $route:{
      handler(val,oldval){
        // log
				if(val.name == "product-manage"){
          this.getdata()
				}
      },
      // 深度观察监听
      deep: true
    }
  },
  computed: {
    isShow() {
      return this.$route.name === "product-manage";
    },
    hasSelected() {
      return this.selectedRowKeys.length > 0;
    },
  },
  methods:{
    getCatagory() {
      this.$http.get("primaryCategory/getPriCateSet").then(res => {
        this.categoryList = res.data;
      });
    },
    getsecCategory() {
      let params = {};
      params.primaryCategoryId = this.searchTerm.primaryCategoryId;
      this.$http.get("secondaryCategory/getSndCateSet", { params }).then(res => {
        this.secCategoryList = res.data;
      });
    },
    handleCategoryChange(input, option) {
      this.getsecCategory();
			this.searchTerm.secondaryCategoryId = undefined;
    },
    handleSecCategoryChange(){
      this.$forceUpdate();
    },
    callback(key) {
      this.tabsKey = key;
      this.pagination.current = 1;
      this.searchTerm.mdseStatus = key ===1?'':key;
      this.getdata();
    },
    checkSelectedisEmpty(index,author){
      if (this.selectedRowKeys.length==0) {
        this.$message.warning("请先选择商品！");
        return true;
      }else{
        let rows = [];//商品id、状态集合
        let selectedRowKeys = []//选中符合状态的商品
        this.data.map(item =>{
          rows[item.mdseId] = item.mdseStatus;
        })
        this.selectedRowKeys.map(item=>{
          if (rows[item] ==index|| rows[item] ==author) {
            selectedRowKeys.push(item);
          }
        })
        if (selectedRowKeys.length==0) {
          this.$message.warning('当前选中的商品无状态可更改！')
          return true; 
        }else{
          if (this.selectedRowKeys.length>selectedRowKeys.length) {
            this.$message.info('选中商品中状态不可更改项已帮您去除')
          }
          this.selectedRowKeys = selectedRowKeys;
          return false;
        }
      }
    },
    //审核
    audit(index){
      if (this.checkSelectedisEmpty(10)) {
        return
      }
      let params = {
        mdseStatus:index,
        mdseIds:this.selectedRowKeys
      }
      batchAudit(params).then(response => {
        if (response.result) {
          this.$message.info('操作成功');
        }else{
          this.$message.warning(response.message);
        }
        this.getdata();
      });
    },
    search(){
      this.pagination.current = 1;
      this.getdata();
    },
    reset(){
      this.pagination.current = 1;
      const key = this.tabsKey;
      this.searchTerm = {
				primaryCategoryId:undefined,
				secondaryCategoryId:undefined,
      };
      this.searchTerm.mdseStatus = key ===1?'':key;
      this.getdata();
    },
    onClick(e){
      let selectedRowKeys = [];
      if ( e.target.checked) {
        this.data.map((item)=>{
          selectedRowKeys.push(item.mdseId)
        }) 
      }
      this.selectedRowKeys = selectedRowKeys;
    },
    onSelectAll(selected, selectedRows, changeRows){
      if (this.selectedRowKeys.length==10) {
        this.checked = true;
      }else{
        this.checked = false;
      }
    },
    getdata(){
      this.checked = false;
      this.selectedRowKeys=[];
      let params = {...this.searchTerm}
      params.pageNum = this.pagination.current;
      this.$http.post('merchandise/queryMdseList',params).then(res=>{
        this.data = res.rows;
        this.pagination.total = res.count;
      })
    },
    onSelectChange(selectedRowKeys) {
      if (selectedRowKeys.length==10) {
        this.checked = true;
      }else if(selectedRowKeys.length==0){
        this.checked = false;
      }
      
      // console.log('selectedRowKeys changed: ', selectedRowKeys);
      this.selectedRowKeys = selectedRowKeys;
    },
    openModal(index,params){
      if (index=='1') {
        if (this.checkSelectedisEmpty(30,40)) {
          return
        }
        this.$refs.transfer.showModal(this.selectedRowKeys)
      }else if (index == '2') {
        this.$router.push({name:'product-detail',query:{id:params}})
      }else if (index=='3') {
        this.$router.push({name:'category-authorize'})
      }
      
    }
  }
};
</script>
<style lang="less" scoped>
.main-container{
  height: 100%;
}
.mdseName{
  display: flex;
  align-items:center;
  img{
    margin-right: 8px;
    width: 60px;
    height: 60px;
	}
	span{
		line-height: 20px;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-overflow: ellipsis;
		word-wrap: break-word;
		word-wrap:break-word;
		white-space: pre-wrap;
		text-overflow: -o-ellipsis-lastline;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;/*重点，不能用block等其他*/
		-webkit-line-clamp: 2;/*重点IE和火狐不支持*/
		-webkit-box-orient: vertical;/*重点*/
	}
}
.product-box{
  span{
    vertical-align: bottom;
  }
  .product-name{
    display: inline-block;
    width:190px;
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
    word-break:keep-all;
  }
}
.search-box{
  padding: 29px 24px;
  margin-bottom: 24px;
  background-color: rgb(247, 248, 249);
  label{
    display:inline-block;
    width: 98px;
    text-align: right;
  }
  .search-item{
    display: inline-block;
    margin-bottom: 16px;
  }
  .search-btn{
    margin-left: 98px;
    .ant-btn{
      margin-right: 8px;
    }
  }
  .ant-select{
    width: 216px;
  }
  .ant-input{
    width: 216px;
    margin-right: 28px;
  }
}
.table-btn{
  .ant-btn{
    margin-right: 12px;
  }
  .last-btn{
    float: right;
    margin-right: 0;
  }
}
.ant-checkbox-wrapper{
  margin:0 24px;
  /deep/.ant-checkbox{
    margin-right: 16px;
  }
}
/deep/.ant-table-thead > tr > th {
    padding: 16px 10px;
}
/deep/.ant-table-tbody > tr > td {
    padding: 16px 10px;
}
</style>
